import { AlertCircle } from "lucide-react";

/**
 * CrossBorderNotice — Phase 43.1
 *
 * Mostra un banner informativo se il ritiro e la consegna si trovano in paesi
 * diversi (es. Svizzera ↔ Italia / Lombardia). Niente blocco, solo trasparenza
 * sulle aspettative MVP.
 *
 * Props:
 *  pickupCountry / deliveryCountry (string|null) — codice paese o nome (es. "Svizzera", "Italia", "CH", "IT").
 *  variant: "info" (default) | "compact"
 */
function normalize(c) {
  if (!c) return null;
  const s = String(c).trim().toLowerCase();
  if (s === "ch" || s.startsWith("svizz") || s === "switzerland") return "CH";
  if (s === "it" || s.startsWith("ital") || s === "italy") return "IT";
  return s.toUpperCase();
}

export default function CrossBorderNotice({ pickupCountry, deliveryCountry, variant = "info", className = "" }) {
  const a = normalize(pickupCountry);
  const b = normalize(deliveryCountry);
  if (!a || !b || a === b) return null;

  const msg = "Per spedizioni transfrontaliere potrebbero applicarsi limitazioni o controlli doganali. Il servizio MVP non include gestione doganale dedicata.";

  if (variant === "compact") {
    return (
      <p
        className={`text-[11px] text-amber-800 inline-flex items-center gap-1.5 ${className}`}
        data-testid="cross-border-notice-compact"
      >
        <AlertCircle className="h-3 w-3 flex-shrink-0" />
        <span>Tratta transfrontaliera · {msg}</span>
      </p>
    );
  }

  return (
    <div
      className={`rounded-2xl border border-amber-200 bg-amber-50 p-3.5 flex items-start gap-2.5 ${className}`}
      data-testid="cross-border-notice"
    >
      <AlertCircle className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" />
      <div className="text-xs text-amber-900">
        <p className="font-semibold">Spedizione transfrontaliera</p>
        <p className="mt-0.5 opacity-90">{msg}</p>
      </div>
    </div>
  );
}
